import { render, staticRenderFns } from "./Bell.vue?vue&type=template&id=21d0b93b"
import script from "./Bell.vue?vue&type=script&lang=js"
export * from "./Bell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports